import { Field } from './field.model';

export class Form {
    public id: string;
    public fields: Field[];    
    constructor(init: Partial<Form>) {
        Object.assign(this, init);
    }
}